import { createBrowserClient as supabaseCreateBrowserClient } from "@supabase/ssr";
import { env } from "@watt/common/config/env";
import type { AppName } from "@watt/common/libs/supabase/cookie-config";
import { getSupabaseCookieName } from "@watt/common/libs/supabase/cookie-config";

export const createBrowserClientForAppName = (appName: AppName) => {
  return supabaseCreateBrowserClient(
    env.NEXT_PUBLIC_SUPABASE_URL,
    env.NEXT_PUBLIC_SUPABASE_PUBLISHABLE_KEY,
    {
      cookieOptions: {
        name: getSupabaseCookieName(appName)
      }
    }
  );
};
